export default "__VITE_ASSET__DzwQ4P$V__"